import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';

var ExclamationTriangleSolidIcon = function (_a) {
    var title = _a.title, props = __rest(_a, ["title"]);
    return (jsxs("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", "data-ui-icon": true }, props, { children: [title ? jsx("title", { children: title }) : null, jsx("path", { d: "M21.895 20.595l-9-18.04c-.339-.68-1.45-.68-1.789 0l-9 18.04A1.004 1.004 0 003 22.045h18a1.002 1.002 0 00.895-1.45zM11 10.018h2v6.014h-2v-6.014zm1 9.271a1.248 1.248 0 01-1.25-1.253A1.254 1.254 0 0112 16.783a1.248 1.248 0 011.25 1.253A1.254 1.254 0 0112 19.29z", fill: "currentColor" })] })));
};

export { ExclamationTriangleSolidIcon };
//# sourceMappingURL=ExclamationTriangleSolidIcon.js.map
